import { render, staticRenderFns } from "./EatingStudyHome.vue?vue&type=template&id=553c227c&scoped=true&"
import script from "./EatingStudyHome.vue?vue&type=script&lang=js&"
export * from "./EatingStudyHome.vue?vue&type=script&lang=js&"
import style0 from "./EatingStudyHome.vue?vue&type=style&index=0&id=553c227c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c227c",
  null
  
)

export default component.exports